import { render, staticRenderFns } from "./portChargesDetail.vue?vue&type=template&id=30b5610c&scoped=true&"
import script from "./portChargesDetail.vue?vue&type=script&lang=js&"
export * from "./portChargesDetail.vue?vue&type=script&lang=js&"
import style0 from "./portChargesDetail.vue?vue&type=style&index=0&id=30b5610c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b5610c",
  null
  
)

export default component.exports